export enum EIAMActionType {
  GET_MY_TENANTS = 'IAM/MY_TENANTS_GET',
  LOADING_MY_TENANTS = 'IAM/MY_TENANTS_LOADING',
  SET_MY_TENANTS = 'IAM/MY_TENANTS_SET',
  USER_LOGIN ='user/LOGIN',
  USER_SESSION_EXPIRED = 'user/SET_SESSION_EXPIRED',
  USER_LOGOUT = 'user/LOGOUT'
}
